<template>
    <Dialog v-model="show" :unlimit-height="true" :title=title width="1100">
        <v-simple-table>
            <thead>
                <tr>
                    <th style="width: 20px;"></th>
                    <th>DATA</th>
                    <th>SITUAÇÃO ANTIGA</th>
                    <th>SITUAÇÃO NOVA</th>
                    <th>MOTIVO</th>
                    <th>USUÁRIO</th>
                    <!-- <th v-if="showDefendeuDadosColumn">DEFENDEU DADOS</th> -->
                </tr>
            </thead>
            <tbody>
                <!--suppress JSUnresolvedVariable -->
                <tr v-for="envio in historico" :key="envio.id_motivo">
                    <td class="align-center">
                        <v-tooltip v-if="envio.id_fonte === FonteMotivoCredito.MOTOR_CREDITO || envio.id_fonte === FonteMotivoCredito.RESPOSTA_ANALISE_MANUAL" bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" color="primary">mdi-help-circle-outline</v-icon>
                            </template>
                            <span v-if="envio.id_fonte === FonteMotivoCredito.MOTOR_CREDITO">Decidido automaticamente via motor de crédito.</span>
                            <span v-else-if="envio.id_fonte === FonteMotivoCredito.RESPOSTA_ANALISE_MANUAL">Decidido manualmente via esteira de crédito</span>
                        </v-tooltip>
                    </td>
                    <td>
                        {{ toDateTimeBR(envio.data_motivo) }}
                    </td>
                    <td>{{ envio.situacao_antiga || '-' }}</td>
                    <td>{{ envio.situacao_nova }}</td>
                    <td>{{ processMotivo(envio.motivo) }}</td>
                    <td>{{ getUsuarioFormatado(envio.usuario) }}</td>
                    <!-- <td v-if="showDefendeuDadosColumn" class="text-center">{{ envio.defendeu_dados === 1 ? 'Sim' : envio.defendeu_dados === 0 ? 'Não' : '-' }}</td> -->
                </tr>
            </tbody>
        </v-simple-table>
        <div class="d-flex justify-center mt-5">
            <v-btn color="primary" @click="dismiss">OK</v-btn>
        </div>
    </Dialog>
</template>

<script>
  import moment from 'moment'
  import { FonteMotivoCredito } from '../../../../plugins/constants'
  export default {
    name: 'DialogHistoryReasonAutorization',
    props: {
      value: Boolean,
      historico: Array,
      title: {
        type: String,
        default: 'HISTÓRICO DE MOTIVOS DA TROCA DE ANÁLISE DE CRÉDITO'
      }
    },
    data () {
      return {
        FonteMotivoCredito: FonteMotivoCredito
      }
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }

      }
      // showDefendeuDadosColumn () {
      //   // Verifica apenas o primeiro item do array
      //   return this.historico &&
      //     this.historico.length > 0 &&
      //     this.historico[0].situacao_nova === SituationAnalysisCredit.PENDENCIA_CADASTRAL
      // }
    },
    methods: {
      dismiss () {
        this.show = false
      },
      primeiraMaiscula (value) {
        return value
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ')
      },
      toDateTimeBR (value) {
        return moment(value, 'YYYY-MM-DD HH:mm:ss.uuu').format('DD/MM/YYYY H:mm:ss')
      },
      getUsuarioFormatado (usuario) {
        if (!usuario) {
          return '-'
        } else if (!usuario.nome) {
          return usuario.login
        } else {
          return usuario.login + ' - ' + usuario.nome
        }
      },

      processMotivo (motivo) {
        return (motivo !== null && motivo.trim() !== '') ? motivo : 'Motivo não informado pelo time de crédito.'
      }

    }

  }
</script>

<style scoped>

</style>
